import React from "react";
import { observer } from "mobx-react-lite";
import { useMatchStatsStore } from "../../../stores/StoreContext";
import { Colors } from "../../../utils/colors";
type props = {
  isShowClutterGraph?: boolean;
};

export const ClutterGraphBoundaryDistribution: React.FC<props> = observer(
  ({ isShowClutterGraph }) => {
    const matchStatsStore = useMatchStatsStore();
    const size =
      (matchStatsStore.filteredShotsMap.get(
        matchStatsStore.selectedFilteredShots
      )?.length ?? 0) > 100
        ? 6
        : 12;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          position: "relative",
        }}>
        {isShowClutterGraph && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}>
            {matchStatsStore.filteredShotsMap
              .get(matchStatsStore.selectedFilteredShots)
              ?.map((item) => {
                const coordinates = JSON.parse(
                  item.normalizedCoordinates ?? ""
                ) as [number, number];
                let x = coordinates[0];
                let y = coordinates[1];

                if (y < 0.5) {
                  x = 1 - x;
                  y = 1 - y;
                }
                if (x < 0) {
                  x = 0;
                }
                if (x > 1) {
                  x = 1;
                }
                if (y < 0) {
                  y = 0;
                }
                if (y > 1) {
                  y = 1;
                }

                return (
                  <div
                    style={{
                      height: size,
                      width: size,
                      borderWidth: 1,
                      borderColor: "white",
                      borderStyle: "solid",
                      borderRadius: 100,
                      backgroundColor: Colors.darkBrown,
                      position: "absolute",
                      top:
                        y * matchStatsStore.height * 2 -
                        matchStatsStore.height -
                        size / 2,
                      left: x * matchStatsStore.width - size / 2,
                    }}
                  />
                );
              })}
          </div>
        )}
        <div style={styles.topHorizontalArea}>
          <div style={styles.topAreaFirstVerticalSection} />
          <div style={styles.topAreaSecondVerticalSection} />
        </div>
        <div style={styles.bottomHorizontalArea} />
      </div>
    );
  }
);

const styles: { [key: string]: React.CSSProperties } = {
  topHorizontalArea: {
    flex: 7,
    width: "100%",
    borderBottomColor: Colors.darkBrown,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    display: "flex",
  },
  bottomHorizontalArea: { flex: 3 },
  topAreaFirstVerticalSection: {
    flex: 1,
    borderRightColor: Colors.darkBrown,
    borderRightWidth: 1,
    borderRightStyle: "solid",
  },
  topAreaSecondVerticalSection: {
    flex: 1,
  },
};
